import { Box, Tooltip } from "@mui/material";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Txt from "../typography/Txt";
import { grey } from "@mui/material/colors";
import { isEmpty, size } from "lodash";
import EnhancedCommentItemRenderer from "../../_src_shared/comments/EnhancedCommentItemRenderer";
import CommentsRenderer from "../renderers/CommentsRenderer";

const CommentThreadPreviewTooltip = ({
  loan,
  comments,
  children,
  enhanced = false,
}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const loanData = useMemo(() => {
    return loan || loanDrilldown;
  }, [loan, loanDrilldown]);
  const tooltipContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
      }}
    >
      {enhanced ? (
        <>
          <Txt
            bold
            sx={{
              color: `${grey[700]} !important`,
              mb: 0.5,
            }}
          >
            Comments ({size(comments)})
          </Txt>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              maxHeight: "540px",
              minWidth: "500px",
              borderRadius: 1.2,
              border: `1px solid ${grey[200]}`,
            }}
          >
            <EnhancedCommentItemRenderer
              sx={{ width: "100%" }}
              loan={loan}
              comments={comments}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            maxHeight: "640px",
            minWidth: "500px",
          }}
        >
          <CommentsRenderer sx={{ width: "100%" }} comments={comments} />
        </Box>
      )}
    </Box>
  );
  return (
    <Tooltip
      title={tooltipContent}
      placement="left"
      disableInteractive={false}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            border: `1px solid ${grey[200]}`,
            p: 1.5,
            maxWidth: "none", // removes MUI's default 300px cap
          },
        },
        arrow: {
          sx: {
            color: "background.paper",
            "&::before": {
              border: `1px solid ${grey[200]}`,
            },
          },
        },
      }}
    >
      <Box>{children}</Box>
    </Tooltip>
  );
};

export default CommentThreadPreviewTooltip;
